export default "__VITE_ASSET__mm9DBWTc__"